import { render, staticRenderFns } from "./EstadoPatente.vue?vue&type=template&id=571d0554&scoped=true&"
import script from "./EstadoPatente.vue?vue&type=script&lang=ts&"
export * from "./EstadoPatente.vue?vue&type=script&lang=ts&"
import style0 from "./EstadoPatente.vue?vue&type=style&index=0&id=571d0554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d0554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('571d0554', component.options)
    } else {
      api.reload('571d0554', component.options)
    }
    module.hot.accept("./EstadoPatente.vue?vue&type=template&id=571d0554&scoped=true&", function () {
      api.rerender('571d0554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MID/EstadoPatente.vue"
export default component.exports